<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less">
  html, body {
    width: 100%;
    height: 100%;
  }

  body {
    overflow: auto !important;
  }

  .app {
    width: 100%;
    height: 100%;
  }
</style>
